import { useEffect, useMemo, useState } from 'react';

import { DataGridIdentifiers, DatagridPremiumUi } from '../Interface';
import { dataGridPremiumColumns } from '../../utils/helper';
import assemblyDefinitionService from '../../service/assemblyDefinition.service';

export const AssemblyDefinitionReports = ({
  refetch,
  values,
  viewField,
  operatorsDisabled,
  rowSelection,
  autoCompleteOptions,
}) => {
  const { refetchTable, setRefetchTable } = refetch;
  const { setSelectedValues } = values;
  const { rowSelectionModel, setRowSelectionModel } = rowSelection;
  const [reports, setReports] = useState({ rows: [], rowCount: 0 });

  const initialState = {
    filter: { filterModel: { items: [], logicOperator: 'and' } },
    sorting: {
      sortModel: [{ field: 'id', sort: 'desc' }],
    },
    pagination: {
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    },
    density: 'compact',
  };

  useEffect(() => {
    if (operatorsDisabled) {
      setRowSelectionModel([]);
    }
  }, [operatorsDisabled, setRowSelectionModel]);

  const getList = (gridState, signal) => {
    assemblyDefinitionService.getItems(gridState, signal).then((data) => {
      setReports(data);
    });
  };

  const columns = useMemo(() => {
    return dataGridPremiumColumns([
      {
        field: 'itemCode',
        headerName: 'Termék',
        type: 'string',
        flex: 1.2,
        renderCell: (data) => {
          return [data.row?.itemCode, data.row?.item?.itemName].filter(Boolean).join(' - ');
        },
      },
      {
        field: 'sourcePriceList',
        headerName: 'Forrás árlista',
        type: 'singleSelect',
        flex: 1,
        valueOptions: autoCompleteOptions.priceList,
        renderCell: (data) => data.row?.priceList?.name ?? '',
      },
      {
        field: 'note',
        headerName: 'Megjegyzés',
        type: 'string',
        flex: 1.4,
      },
    ]);
  }, [autoCompleteOptions.priceList]);

  return (
    <DatagridPremiumUi
      datagridIdentifier={DataGridIdentifiers.assemblyDefinition}
      datagridInitialState={initialState}
      dataLoader={getList}
      rows={reports.rows}
      refetch={{ refetchTable, setRefetchTable }}
      rowCount={reports.rowCount}
      columns={columns}
      onRowClick={(rowData) => {
        if (!viewField) return;

        assemblyDefinitionService.getItemById(rowData.row.id).then((data) => {
          setSelectedValues(data);
        });
      }}
      paginationAndfilterMode="server"
      onRowSelectionModelChange={(newRowSelectionModel) => {
        setRowSelectionModel(newRowSelectionModel);
      }}
      rowSelectionModel={rowSelectionModel}
      disableRowSelectionOnClick={!viewField}
    />
  );
};
